window.PreorderApp = (function () {

  async function addToCart(btn) {
    const variantId = btn.dataset.variantId;
    const productTitle = btn.dataset.productTitle || 'This item';
    const isComingSoon = btn.classList.contains('preorder-btn--coming-soon');

    if (isComingSoon) {
      openNotifyModal(productTitle, btn);
      return;
    }

    setLoading(btn, true);

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: { '_preorder': 'true', '_note': 'Pre-order item' }
        })
      });

      if (!response.ok) throw new Error('Cart error');
      await response.json();
      setSuccess(btn);
      showToast(`✅ "${productTitle}" added as pre-order!`);
      document.dispatchEvent(new CustomEvent('cart:refresh'));

    } catch (err) {
      showToast(`❌ Something went wrong. Please try again.`, true);
    } finally {
      setTimeout(() => setLoading(btn, false), 800);
    }
  }

  function setLoading(btn, loading) {
    const text = btn.querySelector('.preorder-btn__text');
    const loader = btn.querySelector('.preorder-btn__loader');
    btn.disabled = loading;
    if (text) text.style.display = loading ? 'none' : '';
    if (loader) loader.style.display = loading ? 'inline' : 'none';
  }

  function setSuccess(btn) {
    btn.classList.add('preorder-btn--success');
    const text = btn.querySelector('.preorder-btn__text');
    if (text) text.textContent = '✓ Added to Cart';
    setTimeout(() => {
      btn.classList.remove('preorder-btn--success');
      if (text) text.textContent = btn.dataset.originalText || 'Pre-Order Now';
    }, 3000);
  }

  function showToast(message, isError = false) {
    let popup = document.querySelector('.preorder-notify-popup');
    if (!popup) {
      popup = document.createElement('div');
      popup.className = 'preorder-notify-popup';
      popup.innerHTML = `
        <span class="preorder-notify-popup__msg"></span>
        <span class="preorder-notify-popup__close" onclick="this.parentElement.classList.remove('show')">✕</span>
      `;
      document.body.appendChild(popup);
    }
    popup.style.background = isError ? '#dc3545' : '#1A1A1A';
    popup.querySelector('.preorder-notify-popup__msg').textContent = message;
    popup.classList.add('show');
    setTimeout(() => popup.classList.remove('show'), 4000);
  }

  function openNotifyModal(productTitle, btn) {
    let overlay = document.querySelector('.preorder-modal-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'preorder-modal-overlay';
      overlay.innerHTML = `
        <div class="preorder-modal">
          <h3>🔔 Get Notified</h3>
          <p>We'll email you when <strong></strong> is available!</p>
          <input type="email" id="preorder-notify-email" placeholder="your@email.com" />
          <button class="preorder-modal__submit" onclick="PreorderApp.submitNotify()">Notify Me</button>
          <button class="preorder-modal__cancel" onclick="PreorderApp.closeNotifyModal()">Cancel</button>
        </div>
      `;
      document.body.appendChild(overlay);
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) closeNotifyModal();
      });
    }

    const strong = overlay.querySelector('.preorder-modal strong');
    if (strong) strong.textContent = productTitle;
    overlay.dataset.sourceBtnVariant = btn.dataset.variantId;
    overlay.dataset.sourceProductTitle = productTitle;
    requestAnimationFrame(() => overlay.classList.add('show'));
  }

  function closeNotifyModal() {
    const overlay = document.querySelector('.preorder-modal-overlay');
    if (overlay) overlay.classList.remove('show');
  }

  async function submitNotify() {
    const emailInput = document.getElementById('preorder-notify-email');
    const email = emailInput ? emailInput.value.trim() : '';
    const overlay = document.querySelector('.preorder-modal-overlay');
    const productTitle = overlay ? overlay.dataset.sourceProductTitle : 'this product';

    if (!email || !email.includes('@')) {
      emailInput.style.borderColor = '#dc3545';
      emailInput.focus();
      return;
    }

    closeNotifyModal();
    showToast(`🎉 You're on the waitlist for "${productTitle}"!`);
  }

  function init() {
    document.querySelectorAll('[data-preorder-btn]').forEach(btn => {
      const text = btn.querySelector('.preorder-btn__text');
      if (text) btn.dataset.originalText = text.textContent;
    });
  }

  document.addEventListener('DOMContentLoaded', init);

  return { addToCart, showToast, openNotifyModal, closeNotifyModal, submitNotify };

})();